import {
  Card,
  CardBody,
  CardHeader,
  Heading,
  SkeletonText,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import DateTime from "components/ui/DateTime";
import IconButtonLog from "components/ui/IconButtonLog";
import { useResourceList } from "hooks/useResourceList";
import { Outlet } from "react-router-dom";

export const ACTION_NAMES = {
  CREATE: "Criação",
  UPDATE: "Atualização",
  SET_TOPICS: "Notas e resumo",
};

interface LogHistoryProps {
  model: string;
  modelId: string;
}

export default function LogHistory({ model, modelId }: LogHistoryProps) {
  const {
    data: logs,
    isLoading,
    isFetched,
  } = useResourceList({
    resourceName: "logs",
    params: { model, modelId },
  });

  return (
    <>
      <Outlet />
      <Card mt="30px">
        <CardHeader>
          <Heading as="h3" size="h3">
            Histórico de alterações
            <Text as="span"></Text>
          </Heading>
        </CardHeader>
        <CardBody>
          <SkeletonText isLoaded={!isLoading}>
            <TableContainer>
              <Table>
                <Thead>
                  <Tr>
                    <Th>Data</Th>
                    <Th>Usuário</Th>
                    <Th>Ação</Th>
                    <Th w="120px"></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {logs?.map((log) => (
                    <Tr key={log.id}>
                      <Td>
                        <DateTime date={log.createdAt} noBreak />
                      </Td>
                      <Td>{log.user.name}</Td>
                      <Td>
                        {ACTION_NAMES[log.action as keyof typeof ACTION_NAMES]}
                      </Td>
                      <Td>
                        <IconButtonLog to={`logs/${log.id}`} />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </SkeletonText>
        </CardBody>
      </Card>
    </>
  );
}
